import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import './followup.css';
import FormAside from './FormAside';
import FormNotification from './FormNotification';
import MarketingdashboardAside from './MarketingdashboardAside';


function FollowUpManager() {
  const navigate = useNavigate();
  const [institutes, setInstitutes] = useState([]);
  const [selectedInstitute, setSelectedInstitute] = useState('');
  const [employees, setEmployees] = useState([]);
  const [selectedEmployeeId, setSelectedEmployeeId] = useState('');
  const [followUpData, setFollowUpData] = useState({
    empId: '',
    empName: '',
    designation: '',
    instituteName: '',
    instituteAddress: '',
    contactPerson: '',
    contactDesignation: '',
    contactNumber: '',
    lastVisited: '',
    interest: '',
    comment: '',
    interestShown: '',
  });
  const [searchTerm, setSearchTerm] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [followUpList, setFollowUpList] = useState([]);
const [showFollowUps, setShowFollowUps] = useState(false);
const [todayFollowUps, setTodayFollowUps] = useState([]);
const [showTodayFollowUps, setShowTodayFollowUps] = useState(false);
const [selectedInstituteHistory, setSelectedInstituteHistory] = useState([]);
const [showRecordDetails, setShowRecordDetails] = useState(false);
const [mySchoolRecords, setMySchoolRecords] = useState([]);
const [showMySchoolRecords, setShowMySchoolRecords] = useState(false);
const [mySchoolRecordsLoading, setMySchoolRecordsLoading] = useState(false);
const [mySchoolRecordsError, setMySchoolRecordsError] = useState('');
const [popupContactDesignation, setPopupContactDesignation] = useState("");
const [popupContactEmail, setPopupContactEmail] = useState("");
const [employeeShareList, setEmployeeShareList] = useState([]);
const [showEmployeeShareList, setShowEmployeeShareList] = useState(false);
const [employeeShareLoading, setEmployeeShareLoading] = useState(false);
const [employeeShareError, setEmployeeShareError] = useState('');
const [shareSourceRecord, setShareSourceRecord] = useState(null);
const [schoolHistoryPopupLoading, setSchoolHistoryPopupLoading] = useState(false);
const selectedEmployee = employees.find(
  (employee) => String(employee.empId) === String(selectedEmployeeId)
);
const expandMouRows = (records) => {
  const expanded = [];

  records.forEach((record) => {
    expanded.push({
      ...record,
      rowType: record.rowType || 'base',
    });

    if (record.mouSubmittedDate && record.mouSubmittedDate !== '-') {
      expanded.push({
        ...record,
        rowType: 'mou-submitted',
        comment: 'MOU Submitted',
        followupdate: record.mouSubmittedDate,
        lastfollowupdate: record.mouSubmittedDate,
      });
    }

    if (record.mouPaidDate && record.mouPaidDate !== '-') {
      expanded.push({
        ...record,
        rowType: 'payment-received',
        comment: 'Payment Received',
        followupdate: record.mouPaidDate,
        lastfollowupdate: record.mouPaidDate,
      });
    }
  });

  return expanded;
};

const displayedSchoolRecords = selectedInstitute
  ? mySchoolRecords.filter(
      (record) =>
        record.institutename?.trim().toLowerCase() === selectedInstitute.trim().toLowerCase()
    )
  : mySchoolRecords;
const filteredFollowUps = followUpList.filter((record) => {
  const term = searchTerm.toLowerCase();
  return (
    record.institutename?.toLowerCase().includes(term) ||
    record.comment?.toLowerCase().includes(term) ||
    record.interestshown?.toLowerCase().includes(term)
  );
});

const handleTodayFollowUps = async () => {
  try {
    setShowTodayFollowUps(true);
    setShowFollowUps(false);
    setErrorMessage('');

    const token = localStorage.getItem('authToken');
    const empId = localStorage.getItem('empId'); // logged-in employee

    const response = await axios.get(
      `https://cleezoclass.com:8443/api/todays-followups/${empId}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );

    setTodayFollowUps(response.data);
  } catch (error) {
    console.error(error);
    setErrorMessage('Unable to fetch today’s follow-ups');
  }
};

useEffect(() => {
  if (!selectedEmployee) return;

  setFollowUpData((prevData) => ({
    ...prevData,
    empId: selectedEmployee.empId,
    empName: selectedEmployee.empName,
    designation: selectedEmployee.designation || prevData.designation,
  }));
}, [selectedEmployee]);

 const openShareEmployeeModal = async (record) => {
    try {
      setShareSourceRecord(record);
      setEmployeeShareLoading(true);
      setEmployeeShareError('');

      const response = await axios.get(
        'https://cleezoclass.com:8443/api/employee-names'
      );

      console.log('[SalesPerformance] employees loaded for share:', response.data);
      setEmployeeShareList(Array.isArray(response.data) ? response.data : []);
      setShowEmployeeShareList(true);
    } catch (error) {
      console.error('[SalesPerformance] error loading employee names:', {
        message: error.message,
        status: error.response?.status,
        data: error.response?.data,
        url: error.config?.url,
      });
      setEmployeeShareError('Unable to load employees.');
      setShowEmployeeShareList(true);
    } finally {
      setEmployeeShareLoading(false);
    }
  };

const handleShareClick = async () => {
  const sourceRecord = shareSourceRecord || selectedInstituteHistory[0];

  if (!sourceRecord) {
    setErrorMessage('No school selected to share.');
    return;
  }

  await openShareEmployeeModal(sourceRecord);
};

const handleDemoClick = () => {
  window.open('https://cleezoclass.com/book-demo', '_blank', 'noopener,noreferrer');
};

const handleMouClick = () => {
  navigate('/MOUProcess');
};

const handleCentralisationClick = () => {
  navigate('/Centralisation');
};

const handleShareToEmployee = async (selectedEmployee) => {
  try {
    const latestSchool = shareSourceRecord || selectedInstituteHistory[0];

    if (!latestSchool) {
      setErrorMessage('No school selected to share.');
      return;
    }

    if (!selectedEmployee?.empId) {
      setErrorMessage('Employee not selected.');
      return;
    }

    const response = await axios.post('https://cleezoclass.com:8443/api/share-school-history', {
      empId: selectedEmployee.empId,
      empName: selectedEmployee.empName,
      designation: selectedEmployee.designation || followUpData.designation,
      sharedByEmpId: followUpData.empId,
      sharedByEmpName: followUpData.empName,
      sharedByDesignation: followUpData.designation,
      institutename: latestSchool.institutename,
      instituteaddress: popupInstituteAddress || latestSchool.instituteaddress || '',
      contactperson: popupContactPerson || latestSchool.contactperson || '',
      contactpersondesignation: popupContactDesignation || latestSchool.contactpersondesignation || '',
      contactpersonnumber: popupContactNumber || latestSchool.contactnumber || '',
      contactpersonemail: popupContactEmail || latestSchool.email || '',
      followupdate:
        latestSchool.originalStartDate ||
        latestSchool.startdate ||
        latestSchool.date ||
        latestSchool.followupdate ||
        null,
      interestshown: latestSchool.interestshown || 'Follow Up',
      comment: `Shared to ${selectedEmployee.empName} by ${followUpData.empName}`,
    });

    await axios.post('https://cleezoclass.com:8443/api/share-follow-up', {
      empId: followUpData.empId,
      empName: followUpData.empName,
      designation: followUpData.designation,
      institutename: latestSchool.institutename,
      interestshown: latestSchool.interestshown || 'Follow Up',
      comment: `Shared to ${selectedEmployee.empName} by ${followUpData.empName}`,
    });

    if (response.status === 200) {
      setSuccessMessage(`Shared with ${selectedEmployee.empName} successfully.`);
      localStorage.setItem('salesPerformanceRefreshAt', Date.now().toString());
      window.dispatchEvent(new Event('salesPerformanceRefresh'));
      setShowRecordDetails(false);
      setShowEmployeeShareList(false);
      setTimeout(() => setSuccessMessage(''), 5000);
    }
  } catch (error) {
    console.error('Error sharing follow-up:', error);
    setErrorMessage('Unable to share follow-up.');
  }
};

const handleViewMySchools = async () => {
  try {
    setMySchoolRecordsLoading(true);
    setMySchoolRecordsError('');

    const empId = selectedEmployeeId || localStorage.getItem('empId');
    const token = localStorage.getItem('authToken');

    if (!empId) {
      setMySchoolRecordsError('Employee ID not found.');
      setShowMySchoolRecords(true);
      return;
    }

    const response = await axios.get(
      `https://cleezoclass.com:8443/api/sales-performance-schools/${empId}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );

    const records = Array.isArray(response.data)
      ? response.data.map((record) => ({
          empName: record.empName || followUpData.empName,
          institutename: record.institutename || '-',
          instituteaddress: record.instituteaddress || '-',
          contactperson: record.contactperson || '-',
          contactpersondesignation: record.contactpersondesignation || '-',
          contactpersonnumber: record.contactpersonnumber || '-',
          startdate: record.startdate || null,
          followupdate: record.followupdate || '-',
          lastfollowupdate: record.lastfollowupdate || '-',
          date: record.followupdate || record.startdate || record.lastfollowupdate || null,
          mouSubmittedDate: record.mouSubmittedDate || '-',
          mouPaidDate: record.mouPaidDate || '-',
          comment: record.comment || '-',
          interestshown: record.interestshown || '-',
        }))
      : [];

    setMySchoolRecords(expandMouRows(records));
    setShowMySchoolRecords(true);
  } catch (error) {
    console.error('Error fetching school records:', error);
    setMySchoolRecordsError('Unable to load schools for this employee.');
    setShowMySchoolRecords(true);
  } finally {
    setMySchoolRecordsLoading(false);
  }
};

useEffect(() => {
  if (selectedEmployeeId) {
    handleViewMySchools();
  }
}, [selectedEmployeeId]);



  // Check if the user is authenticated
  useEffect(() => {
    const loadEmployees = async () => {
      try {
        const response = await axios.get(
          'https://cleezoclass.com:8443/api/employee-names'
        );
        setEmployees(Array.isArray(response.data) ? response.data : []);
      } catch (error) {
        console.error('Error fetching employees:', error);
        setEmployees([]);
      }
    };

    loadEmployees();
  }, []);

  useEffect(() => {
    const storedEmpId = localStorage.getItem('empId');
    const storedEmpName = localStorage.getItem('empName');
    const storedDesignation = localStorage.getItem('designation');

    if (storedEmpId && storedEmpName && storedDesignation) {
      setSelectedEmployeeId(storedEmpId);
      setFollowUpData((prevData) => ({
        ...prevData,
        empId: storedEmpId,
        empName: storedEmpName,
        designation: storedDesignation,
      }));
    } else {
      alert('Session expired or employee details not found. Please log in again.');
      window.location.href = 'https://crm-nova.tagsol.in';
    }
  }, []);

  // Fetching institute data
  useEffect(() => {
  const empId = selectedEmployeeId || localStorage.getItem('empId');

  if (!empId) {
    console.error('empId missing');
    return;
  }

  axios
    .get(`https://cleezoclass.com:8443/api/institutes/${empId}`)
    .then((response) => {
      console.log('Institutes:', response.data); // 👈 DEBUG
      setInstitutes(response.data);
    })
    .catch((error) => {
      console.error('Error fetching institutes:', error);
    });
}, [selectedEmployeeId]);


  // Fetch sales performance data based on selected institute
  useEffect(() => {
    if (selectedInstitute) {
      const token = localStorage.getItem('authToken');
      axios
        .get(`https://cleezoclass.com:8443/api/sales-performance/${selectedInstitute}`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((response) => {
          const data = response.data;
          setFollowUpData((prevData) => ({
            ...prevData,
            instituteName: data.institutename,
            instituteAddress: data.instituteaddress,
            contactPerson: data.contactperson,
            contactDesignation: data.contactpersondesignation,
            contactNumber: data.contactpersonnumber,
            lastVisited: formatDateToYMD(data.followupdate),
            interest: data.interestshown,
            interestShown: mapInterestToColor(data.interestshown),
          }));
        })
        .catch((error) => console.error('Error fetching selected institute data:', error));
    }
  }, [selectedInstitute]);

  // Helper function to map interest to a color
  const mapInterestToColor = (interest) => {
    if (interest === 'Not Interested') return 'red';
    if (interest === 'Follow Up') return 'yellow';
    if (interest === 'Interested') return 'green';
    return '';
  };

  const formatDateToYMD = (dateValue) => {
    if (!dateValue) return '';

    const date = new Date(dateValue);
    if (Number.isNaN(date.getTime())) {
      return String(dateValue).slice(0, 10);
    }

    return date.toISOString().split('T')[0];
  };

  const formatDisplayDate = (dateValue) => {
    if (!dateValue || dateValue === '-' || dateValue === 'Invalid Date') {
      return '-';
    }

    const date = new Date(dateValue);
    if (Number.isNaN(date.getTime())) {
      return '-';
    }

    return date.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    });
  };

  // Handle input change for follow-up data
  const handleFollowUpChange = (e) => {
    const { name, value } = e.target;
    setFollowUpData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!selectedInstitute) {
      setErrorMessage('Institute name is required!');
      return;
    }

    setFollowUpData((prevData) => ({
      ...prevData,
      instituteName: selectedInstitute,
    }));

    const followUpDataToSend = {
      empId: followUpData.empId,
      empName: followUpData.empName,
      designation: followUpData.designation,
      institutename: followUpData.instituteName,
      interestshown: followUpData.interestShown,
      comment: followUpData.comment,
    };

    try {
      const token = localStorage.getItem('authToken');
      const response = await axios.post('https://cleezoclass.com:8443/api/follow-up', followUpDataToSend, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response.status === 200) {
        setSuccessMessage('Follow-up form submitted successfully!');
        setTimeout(() => setSuccessMessage(''), 5000);

        // Reset form fields after successful submission
        setFollowUpData({
          empId: followUpData.empId,
          empName: followUpData.empName,
          designation: followUpData.designation,
          instituteName: '',
          instituteAddress: '',
          contactPerson: '',
          contactDesignation: '',
          contactNumber: '',
          lastVisited: '',
          interest: '',
          comment: '',
          interestShown: '',
        });
        setSelectedInstitute('');
      }
    } catch (error) {
      console.error('Error submitting follow-up:', error);
      setErrorMessage(error.response?.data || 'Something went wrong.');
    }
  };
const [popupContactPerson, setPopupContactPerson] = useState("");
const [popupContactNumber, setPopupContactNumber] = useState("");
const [popupInstituteAddress, setPopupInstituteAddress] = useState("");
  // Handle tracking of follow-ups
const handleTrackFollowUp = async () => {
  try {
    setShowFollowUps(true);
    setErrorMessage('');

    const token = localStorage.getItem('authToken');
    const empId = selectedEmployeeId || localStorage.getItem('empId'); // selected employee

    const response = await axios.get(
      `https://cleezoclass.com:8443/api/follow-ups/${empId}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );

    setFollowUpList(response.data);
  } catch (error) {
    console.error('Error fetching follow-up data:', error);
    setErrorMessage('Error fetching follow-up data.');
  }
};

const openSchoolHistoryPopup = async (record) => {
  try {
    setShowRecordDetails(true);
    setSchoolHistoryPopupLoading(true);
    await handleOpenRecordDetails(record, mySchoolRecords);
  } catch (error) {
    console.error('Error opening school history popup:', error);
    setErrorMessage('Error opening school history details.');
    setSchoolHistoryPopupLoading(false);
    setShowRecordDetails(true);
    setSelectedInstituteHistory([
      {
        date: record.startdate || record.followupdate || new Date().toISOString(),
        institutename: record.institutename,
        comment: record.comment || '-',
        interestshown: record.interestshown || '-',
      },
    ]);
  }
};

const handleOpenRecordDetails = async (record, sourceList = followUpList) => {
  setShowRecordDetails(true);
  setSchoolHistoryPopupLoading(true);
  try {
    const isSharedHandoffComment = (value) =>
      String(value || '').trim().toLowerCase().startsWith('shared to ');

    const token = localStorage.getItem('authToken');
    const instituteName = record.institutename?.trim();
    if (!instituteName) {
      throw new Error('Institute name is missing.');
    }
    const instituteKey = instituteName.toLowerCase();

    const [historyResponse, detailsResponse] = await Promise.all([
      axios.get(
        `https://cleezoclass.com:8443/api/school-history/${encodeURIComponent(instituteName)}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      ),
      axios.get(
        `https://cleezoclass.com:8443/api/sales-performance/${encodeURIComponent(instituteName)}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      ),
    ]);

    const normalizedHistory = Array.isArray(historyResponse.data)
      ? historyResponse.data
          .map((item) => ({
            ...item,
            date: item.date || item.followupdate || item.startdate || item.lastfollowupdate || null,
            comment: item.comment || '-',
            interestshown: item.interestshown || '-',
          }))
          .filter((item) => !isSharedHandoffComment(item.comment))
          .sort(
            (a, b) =>
              new Date(b.date || b.updated_at || 0) - new Date(a.date || a.updated_at || 0)
          )
      : [];

    const fallbackHistory = sourceList
      .map((item) => ({
        ...item,
        date: item.date || item.followupdate || item.startdate || item.lastfollowupdate || null,
      }))
      .filter(
        (item) =>
          item.institutename?.trim().toLowerCase() === instituteKey &&
          !isSharedHandoffComment(item.comment)
      )
      .sort(
        (a, b) =>
          new Date(b.date || b.followupdate || b.startdate || b.lastfollowupdate || 0) -
          new Date(a.date || a.followupdate || a.startdate || a.lastfollowupdate || 0)
      );

    const instituteHistory = normalizedHistory.length > 0 ? normalizedHistory : fallbackHistory;

    setSelectedInstituteHistory(
      instituteHistory.length > 0
        ? instituteHistory
        : [
            {
              date: record.date || record.startdate || record.followupdate || record.lastfollowupdate || new Date().toISOString(),
              institutename: record.institutename,
              comment: record.comment || '-',
              interestshown: record.interestshown || '-',
            },
          ]
    );
    setShareSourceRecord({
      ...record,
      originalStartDate:
        record.startdate || record.date || record.followupdate || record.lastfollowupdate || null,
    });

    setPopupContactPerson(detailsResponse.data.contactperson || "-");
    setPopupContactDesignation(detailsResponse.data.contactpersondesignation || "-");
    setPopupContactNumber(detailsResponse.data.contactpersonnumber || "-");
    setPopupContactEmail(detailsResponse.data.contactpersonemail || "");
    setPopupInstituteAddress(detailsResponse.data.instituteaddress || "-");
  } catch (error) {
    console.error("Error fetching popup contact details:", error);

    setPopupContactPerson("-");
    setPopupContactDesignation("-");
    setPopupContactNumber("-");
    setPopupContactEmail("");
    setPopupInstituteAddress("-");
  } finally {
    setSchoolHistoryPopupLoading(false);
  }
};



  return (
     <>
    <style>{`
      /* Modal Overlay */
      .sales-modal-overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.55);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 9999;
      }

      /* Modal Content */
      .sales-modal-content {
        background: #ffffff;
        padding: 20px 25px;
        border-radius: 10px;
        width: 90%;
        max-width: 900px;
        max-height: 80vh;
        overflow-y: auto;
        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.25);
        animation: scaleIn 0.25s ease;
      }

      /* Animation */
      @keyframes scaleIn {
        from {
          transform: scale(0.9);
          opacity: 0;
        }
        to {
          transform: scale(1);
          opacity: 1;
        }
      }

      /* Table polish */
      .sales-performance-table {
        width: 100%;
        min-width: 100%;
        table-layout: fixed;
        border-collapse: collapse;
        margin-top: 15px;
      }

      .sales-performance-table th,
      .sales-performance-table td {
        border: 1px solid #ddd;
        padding: 8px;
        text-align: left;
        white-space: normal;
        word-break: break-word;
        overflow-wrap: anywhere;
      }

      .sales-performance-table th {
        background-color: #0a3d62;
        font-weight: 600;
        color:#fff;
        font-size: 0.95rem;
        position: sticky;
        top: 0;
        z-index: 2;
        box-shadow: 0 1px 0 #ddd;
      }

 
      .sales-school-history-card {
        width: 100%;
        margin-top: 24px;
        background: #ffffff;
        border-radius: 10px;
        box-shadow: 0 8px 24px rgba(15, 23, 42, 0.08);
        padding: 20px 24px;
        box-sizing: border-box;
        height: 90vh;
        display: flex;
        flex-direction: column;
        overflow: hidden;
      }
      .sales-school-history-header {
        margin: 0 0 12px;
        color: #2f3b52;
      }
      .sales-school-history-meta {
        margin: 0 0 14px;
        color: #64748b;
        font-size: 0.95rem;
      }
      .sales-school-history-table-wrapper {
        flex: 1;
        overflow: auto;
        width: 100%;
      }
      .sales-school-history-table-wrapper table {
        width: 100%;
        min-width: 100%;
      }
        /* Whole section */
.action-row {
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
}

/* Buttons group */
.action-buttons {
  display: flex;
  justify-content: center;
  gap: 15px;
}

/* Secondary button */
.sales-performance-button.secondary {
  background: #f1f3f6;
  color: #333;
}

/* Icons group */
.action-icons {
  display: flex;
  justify-content: center;
  gap: 30px;
}

/* Icon cards */
.icon-card {
  width: 110px;
  height: 95px;
  border-radius: 14px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  font-size: 34px;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.15);
}

.icon-card span {
  margin-top: 6px;
  font-size: 13px;
  font-weight: 600;
}

/* Email */
.icon-card.mail {
  background: #eef3ff;
  color: #3b6cff;
}

/* WhatsApp */
.icon-card.whatsapp {
  background: #e7f8ef;
  color: #25d366;
}

/* Hover */
.icon-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.25);
}



    `}</style>
   
    
      <div className="sales-performance-page-container">
        <div className="sales-employee-selector-row">
  <div className="marketing-dashboard-select">
                <select
                  value={selectedEmployeeId}
                  onChange={(e) => setSelectedEmployeeId(e.target.value)}
                >
                  {employees.map((employee) => (
                    <option key={employee.empId} value={employee.empId}>
                      {employee.empName} - {employee.designation}
                    </option>
                  ))}
                </select>
              </div></div>
              <FormNotification />
        
      <MarketingdashboardAside />
        <h2 className="follow-up-page-header">Follow-up Page</h2>
        <div className="follow-up-container">
          <form onSubmit={handleSubmit} className="follow-up-form">
            <div className="follow-up-form-row">
             
            </div>
            {/* Row 1: Employee Details */}
            <div className="follow-up-form-row">
              <div className="follow-up-form-group">
                <label>Employee ID:</label>
                <input type="text" name="empId" value={followUpData.empId} disabled />
              </div>
              <div className="follow-up-form-group">
                <label>Employee Name:</label>
                <input type="text" name="empName" value={followUpData.empName} disabled />
              </div>
              <div className="follow-up-form-group">
                <label>Designation:</label>
                <input type="text" name="designation" value={followUpData.designation} disabled />
              </div>
            </div>
  
            {/* Row 2: Institute Name, Institute Address, Contact Person */}
            <div className="follow-up-form-row">
              <div className="follow-up-form-group">
                <label>Institute Name:</label>
                <input
                  type="text"
                  list="institute-options"
                  name="instituteName"
                  value={selectedInstitute}
                  onChange={(e) => setSelectedInstitute(e.target.value)}
                  placeholder="Search institute name..."
                  required
                />
                <datalist id="institute-options">
                  {institutes.map((institute) => (
                    <option key={institute.id || institute.institutename} value={institute.institutename} />
                  ))}
                </datalist>
              </div>
              <div className="follow-up-form-group">
                <label>Institute Address:</label>
                {/* <input type="text" name="instituteAddress" value={followUpData.instituteAddress} disabled /> */}
                {/* to change inpute for temporary */}
                <input type="text" name='instituteaddress' value={followUpData.instituteAddress}/>  


              </div>
              <div className="follow-up-form-group">
                <label>Contact Person:</label>

                <input type="text" name="contactPerson" value={followUpData.contactPerson}  />
              </div>
            </div>
  
            {/* Row 3: Contact Details */}
            <div className="follow-up-form-row">
              <div className="follow-up-form-group">
                <label>Contact Person Designation:</label>

                <input type="text" name="contactDesignation" value={followUpData.contactDesignation}  />
              </div>
              <div className="follow-up-form-group">
                <label>Contact Number:</label>

                <input type="text" name="contactNumber" value={followUpData.contactNumber}  />
              </div>
              <div className="follow-up-form-group">
                <label>Last Visited:</label>
                
                <input type="text" name="lastVisited" value={followUpData.lastVisited || 'N/A'}  />
              </div>
            </div>
  
            {/* Row 4: Interest (Add empty placeholders for 3 columns) */}
            <div className="follow-up-form-row">
              <div className="follow-up-form-group">
                <label>Interest Type:</label>
                <div
                  className="follow-up-interest-circle"
                  style={{ backgroundColor: followUpData.interestShown }}
                ></div>
              </div>
              <div className="follow-up-form-group"></div>
              <div className="follow-up-form-group"></div>
            </div>
  
            <h3>Update Follow-up:</h3>
            {/* Row 5: Update Follow-up - Comment & Interest Shown */}
            <div className="follow-up-form-row">
              <div className="follow-up-form-group">
                <label>Comment:</label>
                <textarea name="comment" value={followUpData.comment} onChange={handleFollowUpChange} required></textarea>
              </div>
              <div className="follow-up-form-group">
                <label>Interest Shown:</label>
                <div className="follow-up-interest-circles">
                  <div
                    className={`follow-up-interest-circle red ${followUpData.interestShown === 'red' ? 'selected' : ''}`}
                    onClick={() => setFollowUpData({ ...followUpData, interestShown: 'red' })}
                  ></div>
                  <div
                    className={`follow-up-interest-circle yellow ${followUpData.interestShown === 'yellow' ? 'selected' : ''}`}
                    onClick={() => setFollowUpData({ ...followUpData, interestShown: 'yellow' })}
                  ></div>
                  <div
                    className={`follow-up-interest-circle green ${followUpData.interestShown === 'green' ? 'selected' : ''}`}
                    onClick={() => setFollowUpData({ ...followUpData, interestShown: 'green' })}
                  ></div>
                </div>
              </div>
              <div className="follow-up-form-group"></div>
            </div>
  
            {errorMessage && <p className="follow-up-error-message">{errorMessage}</p>}
            {successMessage && <p className="follow-up-success-message">{successMessage}</p>}
            <div className="follow-up-actions-bar">
              <button type="submit" className="follow-up-submit-button">
                Submit Follow-up
              </button>

              <button
                type="button"
                onClick={handleTrackFollowUp}
                className="follow-up-track-button"
              >
                Track Follow-ups
              </button>

              <button
                type="button"
                onClick={handleTodayFollowUps}
                className="follow-up-today-button"
              >
                Today’s Follow-ups
              </button>
            </div>

          {(showMySchoolRecords || displayedSchoolRecords.length > 0) && (
            <div className="sales-school-history-card">
              {!selectedEmployeeId ? (
                <p>Loading employee details...</p>
              ) : mySchoolRecordsLoading ? (
                <p>Loading school history...</p>
              ) : mySchoolRecordsError ? (
                <p className="follow-up-error-message" style={{ marginTop: 0 }}>
                  {mySchoolRecordsError}
                </p>
              ) : displayedSchoolRecords.length > 0 ? (
                <div className="sales-school-history-table-wrapper">
                  <table className="sales-performance-table">
                    <thead>
                      <tr>
                        <th>Employee Name</th>
                        <th>Institute Name</th>
                        <th>Address</th>
                        <th>Contact Name</th>
                        <th>Contact Designation</th>
                        <th>Contact Number</th>
                        <th>Start Date</th>
                        <th>Follow-Up Date</th>
                        <th>Last Date</th>
                        <th>Comment</th>
                      </tr>
                    </thead>
                    <tbody>
                      {displayedSchoolRecords.map((record, index) => {
                        const rowColor =
                          record.rowType === 'mou-submitted'
                            ? '#047857'
                            : record.rowType === 'payment-received'
                              ? '#1d4ed8'
                              : 'inherit';

                        return (
                        <tr
                          key={`${record.institutename}-${index}`}
                          style={{ color: rowColor }}
                        >
                          <td style={{ color: rowColor }}>{record.empName || '-'}</td>
                          <td
                            style={{
                              color: rowColor === 'inherit' ? '#007bff' : rowColor,
                              cursor: 'pointer',
                              textDecoration: 'underline',
                            }}
                            title="View history"
                            onClick={() => openSchoolHistoryPopup(record)}
                          >
                            {record.institutename || '-'}
                          </td>
                          <td style={{ color: rowColor }}>{record.instituteaddress || '-'}</td>
                          <td style={{ color: rowColor }}>{record.contactperson || '-'}</td>
                          <td style={{ color: rowColor }}>{record.contactpersondesignation || '-'}</td>
                          <td style={{ color: rowColor }}>{record.contactpersonnumber || '-'}</td>
                          <td style={{ color: rowColor }}>
                            {formatDisplayDate(record.startdate)}
                          </td>
                          <td style={{ color: rowColor }}>
                            {formatDisplayDate(record.followupdate)}
                          </td>
                          <td style={{ color: rowColor }}>
                            {formatDisplayDate(record.lastfollowupdate)}
                          </td>
                        <td
  style={{
    color: record.comment?.includes('Shared to') ? 'green' : 'inherit',
    fontWeight: record.comment?.includes('Shared to') ? '600' : 'normal',
  }}
>{record.comment || '-'}</td>
                        </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              ) : (
                <p>
                  {selectedInstitute
                    ? `No schools found for ${selectedInstitute}.`
                    : 'No schools found for this employee.'}
                </p>
              )}
            </div>
          )}

          </form>
  
          {showFollowUps && (
    <div className="followup-details-overlay" onClick={() => setShowFollowUps(false)}>
    <div className="followup-modal-content" onClick={(e) => e.stopPropagation()}>
  <h3>Follow-up Records</h3>

  {/* Search Bar */}
  <input
    type="text"
    placeholder="Search by Institute, Comment, or Interest..."
    value={searchTerm}
    onChange={(e) => setSearchTerm(e.target.value)}
    className="followup-search-input"
  />

  <table className="follow-up-table">
    <thead>
      <tr>
        <th>Date</th>
        <th>Institute Name</th>
        <th>Comment</th>
        <th>Interest Shown</th>
      </tr>
    </thead>
    <tbody>
      {filteredFollowUps.length > 0 ? (
        filteredFollowUps.map((record) => (
        <tr key={`${record.source || 'FollowUp'}-${record.followup_id || record.institutename || 'record'}-${record.date || ''}`}>
            <td>{new Date(record.date).toLocaleDateString('en-IN')}</td>
            <td
  style={{
    color: "#007bff",
    cursor: "pointer",
    textDecoration: "underline"
  }}
  onClick={() => handleOpenRecordDetails(record)}
>
  {record.institutename}
</td>
            <td>{record.comment || '-'}</td>
            <td>{record.interestshown}</td>
          </tr>
        ))
      ) : (
        <tr>
          <td colSpan="4">No records found</td>
        </tr>
      )}
    </tbody>
  </table>
</div>
</div>

)}

  {showTodayFollowUps && (
  <div
    className="followup-details-overlay"
    onClick={() => setShowTodayFollowUps(false)}
  >
    <div
      className="followup-modal-content"
      onClick={(e) => e.stopPropagation()}
    >
      <h3>Today’s Follow-ups</h3>

      <table className="follow-up-table">
        <thead>
          <tr>
            <th>Date</th>
            <th>Institute</th>
            <th>Comment</th>
            <th>Interest</th>
            
          </tr>
        </thead>
        <tbody>
          {todayFollowUps.length > 0 ? (
            todayFollowUps.map((item) => (
              <tr key={`${item.institutename}-${item.date}-${item.source}`}>
               <td>{new Date(item.date).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })}</td>
                <td>{item.institutename}</td>
                <td>{item.comment || '-'}</td>
                <td>{item.interestshown}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="5">No follow-ups for today 🎉</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  </div>
)}

{showRecordDetails && (
  <div
    className="followup-details-overlay"
    onClick={() => setShowRecordDetails(false)}
  >
    <div
      className="followup-modal-content"
      onClick={(e) => e.stopPropagation()}
    >
      <h3>
       <div
  style={{
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "20px",
  }}
>
  {/* Left side contact */}
 <div
  style={{
    fontSize: "14px",
    fontWeight: "600",
    display: "flex",
    flexDirection: "column",
    gap: "4px",
  }}
>
  <div>👤 {popupContactPerson || "-"}</div>
  <div>📞 {popupContactNumber || "-"}</div>
</div>

  {/* Center title */}
 <div
  style={{
    flex: 1,
    textAlign: "center",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  }}
>
  <h3 style={{ margin: 0 }}>
     History -{" "}
    {selectedInstituteHistory[0]?.institutename || 'School History'}
  </h3>

  <div
    style={{
      fontSize: "12px",
      color: "#666",
      marginTop: "4px",
    }}
  >
    📍 {popupInstituteAddress || "-"}
  </div>
</div>

  {/* Right empty space */}
<div
  style={{
    width: "260px",
    textAlign: "left",
    fontSize: "12px",
  }}
>
  <div
    style={{
      fontWeight: "700",
      marginBottom: "6px",
      fontSize: "13px",
    }}
  >
    Last Comments
  </div>

  {(selectedInstituteHistory.length > 0 ? selectedInstituteHistory : []).slice(0, 3).map((item, index) => (
      <div
        key={index}
        style={{
          marginBottom: "4px",
          color: "#555",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        • {item.comment || "-"}
      </div>
    ))}
</div>
</div>
      </h3>

      {schoolHistoryPopupLoading ? (
        <p>Loading history...</p>
      ) : (
      <table className="follow-up-table">
        <thead>
          <tr>
            <th>Date</th>
            <th>Comment</th>
            <th>Interest</th>
          </tr>
        </thead>
        <tbody>
      {(selectedInstituteHistory.length > 0 ? selectedInstituteHistory : [{ date: new Date().toISOString(), comment: '-', interestshown: '-' }]).map((item, index) => (
            <tr key={index}>
              <td>{new Date(item.date).toLocaleDateString("en-IN")}</td>
              <td>{item.comment || "-"}</td>
              <td>{item.interestshown || "-"}</td>
            </tr>
          ))}
        </tbody>
      </table>
      )}

      <div className="followup-popup-actions">
        <button
          type="button"
          onClick={() => setShowRecordDetails(false)}
          className="follow-up-submit-button"
        >
          Close
        </button>
        <button
          type="button"
          onClick={handleShareClick}
          className="follow-up-submit-button"
        >
          Share FollowUp
        </button>
        <button
          type="button"
          onClick={handleDemoClick}
          className="follow-up-submit-button"
        >
          Demo
        </button>
        <button
          type="button"
          onClick={handleMouClick}
          className="follow-up-submit-button"
        >
          MOU
        </button>
        <button
          type="button"
          onClick={handleCentralisationClick}
          className="follow-up-submit-button"
        >
          Centralisation
        </button>
      </div>
    </div>
  </div>
)}

{showEmployeeShareList && (
  <div
    className="followup-share-overlay"
    onClick={() => setShowEmployeeShareList(false)}
  >
    <div
      className="followup-share-content"
      onClick={(e) => e.stopPropagation()}
    >
      <h3>Select Employee to Share With</h3>
      <div style={{ marginBottom: '12px', color: '#64748b', fontSize: '14px' }}>
        Sharing: <strong>{shareSourceRecord?.institutename || selectedInstituteHistory[0]?.institutename || '-'}</strong>
      </div>

      {employeeShareLoading ? (
        <p>Loading employees...</p>
      ) : employeeShareError ? (
        <p style={{ color: 'red' }}>{employeeShareError}</p>
      ) : (
        <div
          style={{
            display: 'grid',
            gap: '10px',
            maxHeight: '50vh',
            overflowY: 'auto',
            paddingRight: '6px',
          }}
        >
          {employeeShareList.length > 0 ? (
            employeeShareList.map((employee) => (
              <button
                key={employee.empId || employee.empName}
                type="button"
                onClick={() => handleShareToEmployee(employee)}
                style={{
                  padding: '12px 14px',
                  border: '1px solid #ddd',
                  borderRadius: '8px',
                  background: '#f8fafc',
                  textAlign: 'left',
                  cursor: 'pointer',
                  fontSize: '15px',
                  color:'#333'
                }}
              >
                {employee.empName}
                {employee.empId ? ` (${employee.empId})` : ''}
                {employee.designation ? ` - ${employee.designation}` : ''}
              </button>
            ))
          ) : (
            <p>No employees found.</p>
          )}
        </div>
      )}

      <button
        onClick={() => setShowEmployeeShareList(false)}
        className="follow-up-submit-button"
        style={{ marginTop: '16px' }}
      >
        Cancel
      </button>
    </div>
  </div>
)}
        </div>
      </div>
  </>
      )}
      
    

export default FollowUpManager;
